const translations = {
  "en": {
    "Claim Credits": "Claim Credits",
    "Claim your pending credits to unlock the chat and continue right where you left off.": "Claim your pending credits to unlock the chat and continue right where you left off.",
    "Earn Credits": "Earn Credits",
    "Free credits available": "Free credits available",
    "Keep the chat going!": "Keep the chat going!",
    "Only $%{var0}": "Only $%{var0}",
    "See all plans": "See all plans",
    "Start free trial": "Start free trial",
    "Start Free Trial": "Start Free Trial",
    "Subscribe Ed Complete": "Subscribe Ed Complete",
    "Uh oh! You've reached your usage limit!": "Uh oh! You've reached your usage limit!",
    "Upgrade to continue reading and exploring with Ed": "Upgrade to continue reading and exploring with Ed",
    "Upgrade to Ed Complete": "Upgrade to Ed Complete",
    "You can resume your conversation on {resumeTime}. Check out Invest while you wait.": "You can resume your conversation on {resumeTime}. Check out Invest while you wait.",
    "You're out of credits! Earn more in just 2 minutes by completing a simple task.": "You're out of credits! Earn more in just 2 minutes by completing a simple task."
  },
  "zh-tw": {
    "Claim Credits": "領取點數",
    "Claim your pending credits to unlock the chat and continue right where you left off.": "請領取你待處理的點數以解鎖聊天，並從你離開的地方繼續。",
    "Earn Credits": "賺取點數",
    "Free credits available": "可用的免費點數",
    "Keep the chat going!": "繼續聊天吧！",
    "Only $%{var0}": "只需 $%{var0}",
    "See all plans": "查看所有方案",
    "Start free trial": "開始免費試用",
    "Start Free Trial": "開始免費試用",
    "Subscribe Ed Complete": "訂閱 Ed Complete",
    "Uh oh! You've reached your usage limit!": "糟糕！你已達到使用上限！",
    "Upgrade to continue reading and exploring with Ed": "升級以繼續與 Ed 一起閱讀與探索",
    "Upgrade to Ed Complete": "升級至 Ed Complete",
    "You can resume your conversation on {resumeTime}. Check out Invest while you wait.": "你可以在 {resumeTime} 繼續對話。等待時不妨看看 Invest。",
    "You're out of credits! Earn more in just 2 minutes by completing a simple task.": "你的點數用完了！只需 2 分鐘完成一個簡單任務即可獲得更多點數。"
  }
};

export default translations;
